module.exports = __webpack_public_path__ + "img/fcl-lcl.c3a27f44.jpg";